import { Typography as MuiTypography, TypographyProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FC, PropsWithChildren } from "react";

export type Variant = "h1" | "h2" | "h3" | "regular" | "regular-semi" | "s" | "s-semi" | "xs";

interface TextBaseProps extends Omit<TypographyProps, "variant"> {
  variant?: Variant;
  component?: keyof JSX.IntrinsicElements;
}

const StyledTypography = styled(MuiTypography)(({ theme, color }) => ({
  "&.MuiTypography-h1": {
    fontSize: "30px",
    fontWeight: 700,
    color: color || theme.myTheme.colors.foreground100,
  },
  "&.MuiTypography-h2": {
    fontSize: "20px",
    fontWeight: 600,
    color: color || theme.myTheme.colors.foreground100,
  },
  "&.MuiTypography-h3": {
    fontSize: "14px",
    fontWeight: 700,
    textTransform: "uppercase",
    color: color || theme.myTheme.colors.foreground100,
  },
  "&.MuiTypography-regular-semi": {
    fontSize: "14px",
    fontWeight: 600,
    color: color || theme.myTheme.colors.foreground100,
  },
  "&.MuiTypography-regular": {
    fontSize: "14px",
    fontWeight: 400,
    color: color || theme.myTheme.colors.foreground100,
  },
  "&.MuiTypography-s": {
    fontSize: "12px",
    fontWeight: 400,
    color: color || theme.myTheme.colors.foreground100,
  },
  "&.MuiTypography-s-semi": {
    fontSize: "12px",
    fontWeight: 600,
    color: color || theme.myTheme.colors.foreground100,
  },
  "&.MuiTypography-xs": {
    fontSize: "10px",
    fontWeight: 400,
    color: color || theme.myTheme.colors.foreground100,
  },
}));

const Text: FC<PropsWithChildren<TextBaseProps>> = ({ children, variant, ...props }) => {
  return (
    <StyledTypography {...props} className={`MuiTypography-${variant}`}>
      {children}
    </StyledTypography>
  );
};

export default Text;
